/* esm.sh - dijkstrajs@1.0.3 */
export * from "/*dijkstrajs@1.0.3/esnext/dijkstrajs.mjs";
export { default } from "/*dijkstrajs@1.0.3/esnext/dijkstrajs.mjs";
